import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const fieldLight =
  "border-[rgba(15,23,42,0.09)] bg-white text-[#101828] shadow-[var(--shadow-card)] placeholder:text-[#576274] focus:border-[rgba(147,51,245,0.4)] focus:ring-[rgba(59,130,246,0.15)]"
const fieldDark =
  "dark:border-indigo-300/20 dark:bg-slate-950/45 dark:text-white dark:shadow-none dark:placeholder:text-slate-400 dark:focus:border-violet-400/70 dark:focus:ring-violet-400/25"

const inputClassName =
  `flex h-10 w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50 ${fieldLight} ${fieldDark}`

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [visible, setVisible] = React.useState(false)
    const isPassword = type === "password"

    if (isPassword) {
      return (
        <div className="relative">
          <input
            type={visible ? "text" : "password"}
            className={cn(inputClassName, "pr-10", className)}
            ref={ref}
            {...props}
          />
          <button
            type="button"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-[#576274] transition-colors hover:text-[#101828] dark:text-slate-400 dark:hover:text-slate-200"
            onClick={() => setVisible((v) => !v)}
            aria-label={visible ? "Hide password" : "Show password"}
            tabIndex={-1}
          >
            {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      )
    }

    return (
      <input
        type={type}
        className={cn(inputClassName, className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
